import {
  CREST_COLORS,
  CREST_EMBLEM_IDS,
  type CrestColorId,
  type CrestEmblemId,
} from '../../../components/worldcup/CreateWorldCupGroupScreen/CreateWorldCupGroupScreen.constants';

/**
 * Deterministically derives a crest color and emblem from a group's ID/name so
 * every squad always shows the same consistent crest, even when no explicit
 * crest was chosen or persisted.
 */
export function deriveGroupCrest(groupId: string, groupName: string): {
  colorId: CrestColorId;
  emblemId: CrestEmblemId;
} {
  const seed = groupId.length > 0 ? groupId : groupName;
  const hash = seed.split('').reduce((acc, ch) => ((acc * 31 + ch.charCodeAt(0)) | 0), 0);
  const abs = Math.abs(hash);
  return {
    colorId: CREST_COLORS[abs % CREST_COLORS.length]!.id,
    emblemId: CREST_EMBLEM_IDS[(abs >> 4) % CREST_EMBLEM_IDS.length]!,
  };
}
